import { render, staticRenderFns } from "./BowMenuToggle.vue?vue&type=template&id=5fd2b221&"
import script from "./BowMenuToggle.vue?vue&type=script&lang=js&"
export * from "./BowMenuToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports